// Bootstrap do navegador (React): QueryClient + Router. Toda a regra anti-botão-falso continua
// em view-model/capability/registry-client (agnósticas de framework). Aqui só montamos os providers.
import React, { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { i18nReady } from "./i18n.js";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import "./index.css";
import { router } from "./router.js";
import { queryClient } from "./lib/query-client.js";
import { AppErrorBoundary } from "./lib/app-error-boundary.js";
import { registerAppServiceWorker } from "./lib/app-sw-update.js";
import { initPostHog } from "./lib/posthog.js";

// Devtools só em desenvolvimento. `import.meta.env.DEV` vira `false` no build de
// produção, então o import() é eliminado (tree-shaking) e não pesa o bundle do site.
const ReactQueryDevtools = import.meta.env.DEV
  ? lazy(() =>
      import("@tanstack/react-query-devtools").then((m) => ({ default: m.ReactQueryDevtools })),
    )
  : () => null;

// Antes do render: só dispara o carregamento (dinâmico) da lib; os eventos que
// chegarem antes dela ficam na fila de lib/posthog.ts. Sem chave, não faz nada.
initPostHog();

const root = document.getElementById("app");
if (root) {
  // Espera o catálogo do idioma ativo antes do primeiro render. Os idiomas agora
  // são carregados sob demanda (src/i18n.ts) e renderizar antes disso pintaria a
  // chave crua ("common.language") por um frame. É uma requisição só, disparada
  // no mesmo instante que o bundle do app — sem estado de carregamento na tela.
  void i18nReady.then(() =>
    createRoot(root).render(
      <React.StrictMode>
        {/* Error boundary global: fora do RouterProvider de propósito — o
            CatchBoundary do router vive DENTRO dele e não cobre falha nos
            providers nem na própria montagem do router. */}
        <AppErrorBoundary>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
            <Suspense fallback={null}>
              <ReactQueryDevtools initialIsOpen={false} />
            </Suspense>
          </QueryClientProvider>
        </AppErrorBoundary>
      </React.StrictMode>,
    ),
  );
}

// Registro do SW fora da árvore React: não depende da montagem e sobrevive a
// um erro de render (é justamente aí que a versão nova mais importa).
registerAppServiceWorker();
